/**
 * Creates a generic API module with common HTTP methods.
 * @param request - The configured request function from the API client.
 * @returns An object containing generic HTTP methods.
 */
export function createApiModule(request) {
    return {
        /**
         * Performs a GET request.
         * @param url - The endpoint URL.
         * @param params - Optional query parameters.
         * @param requireAuth - Optional, defaults to true. Whether authentication is required.
         * @param headers - Optional custom headers.
         * @returns A promise resolving to the response data.
         */
        get: (url, params, requireAuth = true, // Common default for general API calls
        headers, monitoringMetadata) => {
            return request('GET', url, requireAuth, params, headers, monitoringMetadata);
        },
        /**
         * Performs a POST request.
         * @param url - The endpoint URL.
         * @param data - The request payload.
         * @param requireAuth - Optional, defaults to true. Whether authentication is required.
         * @param headers - Optional custom headers.
         * @returns A promise resolving to the response data.
         */
        post: (url, data, requireAuth = true, headers, monitoringMetadata) => {
            return request('POST', url, requireAuth, data, headers, monitoringMetadata);
        },
        /**
         * Performs a PUT request.
         * @param url - The endpoint URL.
         * @param data - The request payload.
         * @param requireAuth - Optional, defaults to true. Whether authentication is required.
         * @param headers - Optional custom headers.
         * @returns A promise resolving to the response data.
         */
        put: (url, data, requireAuth = true, headers, monitoringMetadata) => {
            return request('PUT', url, requireAuth, data, headers, monitoringMetadata);
        },
        /**
         * Performs a PATCH request.
         * @param url - The endpoint URL.
         * @param data - The request payload.
         * @param requireAuth - Optional, defaults to true. Whether authentication is required.
         * @param headers - Optional custom headers.
         * @returns A promise resolving to the response data.
         */
        patch: (url, data, requireAuth = true, headers, monitoringMetadata) => {
            return request('PATCH', url, requireAuth, data, headers, monitoringMetadata);
        },
        /**
         * Performs a DELETE request.
         * @param url - The endpoint URL.
         * @param data - Optional request payload (some APIs use this).
         * @param requireAuth - Optional, defaults to true. Whether authentication is required.
         * @param headers - Optional custom headers.
         * @returns A promise resolving to the response data.
         */
        del: (// Renamed from 'delete'
        url, data, requireAuth = true, headers, monitoringMetadata) => {
            return request('DELETE', url, requireAuth, data, headers, monitoringMetadata);
        },
    };
}
//# sourceMappingURL=api.js.map